import React, { useState, useEffect } from 'react';
import { useTranslate } from '../hooks/useTranslate';
import { OptimizedImage } from '../components/ui/optimized-image';

const Terms = () => {
  const [pageData, setPageData] = useState(null);
  const [loading, setLoading] = useState(true);
  const API_BASE = process.env.REACT_APP_BACKEND_URL || '';

  // Traductions
  const { translatedText: titleTranslated } = useTranslate(pageData?.title || "Conditions d'utilisation");
  const { translatedText: contentTranslated } = useTranslate(pageData?.content || "");

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const response = await fetch(`${API_BASE}/api/site/pages/terms`);
      if (response.ok) {
        const data = await response.json();
        setPageData(data);
      }
    } catch (error) {
      console.error('Erreur chargement:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="min-h-screen bg-white flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2" style={{ borderBottomColor: 'rgb(196, 150, 96)' }}></div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-white">
      {/* Header Image */}
      {pageData?.header_image && (
        <div 
          className="relative w-full overflow-hidden"
          style={{ 
            height: '600px',
            marginTop: '-80px',
            paddingTop: '80px'
          }}
        >
          <OptimizedImage 
            src={pageData.header_image.startsWith('/api/files/') || pageData.header_image.startsWith('http') ? (pageData.header_image.startsWith('http') ? pageData.header_image : `${API_BASE}${pageData.header_image}`) : `${API_BASE}/api/files/${pageData.header_image}`}
            alt={pageData.title}
            className="absolute inset-0 w-full h-full object-cover"
            priority={true}
            placeholder="blur"
          />
          <div className="absolute inset-0 bg-black bg-opacity-30"></div>
          <div className="absolute inset-0 flex flex-col items-center justify-center" style={{ paddingTop: '100px' }}>
            <h1 
              className="text-5xl font-bold text-center px-4"
              style={{ 
                fontFamily: '"Lora", serif',
                color: 'rgb(196, 150, 96)',
                textShadow: '3px 3px 6px rgba(0,0,0,0.8), -1px -1px 2px rgba(255,255,255,0.3)'
              }}
            >
              {titleTranslated}
            </h1>
          </div>
        </div>
      )}

      <div className="py-24">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          {/* Titre si pas d'image header */}
          {!pageData?.header_image && (
            <div className="text-center mb-12">
              <h1 
                className="text-5xl font-bold mb-4"
                style={{ 
                  fontFamily: '"Lora", serif',
                  color: 'rgb(196, 150, 96)'
                }}
              >
                {titleTranslated}
              </h1>
              <div className="w-24 h-1 mx-auto" style={{ backgroundColor: 'rgb(196, 150, 96)' }}></div>
            </div>
          )}

          {/* Contenu */}
          <div 
            className="prose prose-lg max-w-none"
            style={{ fontFamily: '"Lora", serif' }}
            dangerouslySetInnerHTML={{ __html: contentTranslated }}
          />
        </div>
      </div>
    </div>
  );
};

export default Terms;
